export default {
  appointment: "appointment",
  contact: "contact",
  merchant: "merchant",
  contactCodeVerification: "contact-code-verification",
  creditInfo: "credit-info",
  delivery: "delivery",
  deliveryReview: "delivery-review",
  feedbackThanks: "feedback-thanks",
  IbanVerification: "iban-verification",
  incomeVerification: "income-verification",
  incomeVerificationReview: "income-verification-review",
  incomeVerificationStpReview: "income-verification-stp-review",
  incomeVerificationReviewStaff: "incomeVerificationReviewStaff",
  contactInfo: "contactInfo",
  eligibility: "eligibility",
  eligibility2: "eligibility",
  personalInfo: "personalInfo",
  rejectedBureauScore: "rejected-bureau-score",
  ocr: "ocr",
  identity: "identity",
  uploadIdentity: "upload-identity",
  employment: "employment",
  employmentDetails: "employment-details",
  additionalInformation: "additional-information",
  loanReview: "review-loan-what-for",
  loanReviewConfirmation: "loan-review-confirmation",
  identityReview: "identity-review",
  executiveReferal: "executive-login-step",
  stpSales: "stpSales",
  balanceTransfer: "balanceTransfer",
  // example-api-call
  cifNumber: "cif-number",
  fullNameApi: "full-name-api",
  // example-custom-flow
  stepOne: "step-1",
  stepTwo: "step-2",
  stepThree: "step-3",
  stepFour: "step-4",
  // second-onboarding
  datosPersonales: "datos-personales",
  email: "email",
  // feedback
  feedback: "feedback",
  // Stored Value Card
  welcome: "welcome",
  welcome2: "welcome2",
  customerConsent: "customerConsent",
  cardDetails: "card-details",
  setAccountPassword: "set-account-password",
  // Credit Card
  creditCardLimit: "credit-card-limit",
  creditCardLimitReview: "credit-card-limit-review",
  approvedLimitReview: "approved-limit-review",
  doubleSecureInsurance: "double-secure-insurance",
  // Suplementary Card
  supplementaryCard: "supplementary-card",
  // needs-review
  payslipOnePassword: "payslip-1-Password",
  payslipTwoPassword: "payslip-2-Password",
  payslipThreePassword: "payslip-3-Password",
  //Insurance
  insuranceType: "isnuranceType",
  //Referral Welcome
  referralWelcome: "referralWelcome",
  referralThankYou: "referralthankyou",
  cardReader: "cardReader",
  //Auto Loan
  salesAuto: "salesAuto",
  //Onboarding Digital
  continue: "continue",
  choice: "choice",
  loan: "loan",
  creditCard: "creditCard",
  uploadIdentityDigital: "uploadIdentityDigital",
  identityReviewDigital: "identityReviewDigital",
  employmentDetailsDigital: "employmentDetailsDigital",
  appointmentDigital: "appointmentDigital",
  otpVerificationDigital: "otpVerificationDigital",
  insuranceDigital: "insuranceDigital",
  personalInfoDigital: "personalInfoDigital"
};
